import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const faqItems = [
  { q: 'faq_q1', a: 'faq_a1' },
  { q: 'faq_q2', a: 'faq_a2' },
  { q: 'faq_q3', a: 'faq_a3' },
  { q: 'faq_q4', a: 'faq_a4' },
  { q: 'faq_q5', a: 'faq_a5' },
];

export default function FAQ() {
  const { t } = useTranslation('refection');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section ref={ref} id="faq" className="bg-soft-gray py-16 md:py-24">
      <div className="max-w-3xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          className={`text-center mb-10 md:mb-14 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl mb-3">
            {t('faq_h2')}
          </h2>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className={`bg-white rounded-lg border border-soft-dark overflow-hidden transition-all duration-1000 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
              }`}
              style={{ transitionDelay: `${idx * 100}ms` }}
            >
              <button
                onClick={() => toggle(idx)}
                className="w-full flex items-center justify-between gap-4 p-4 md:p-5 text-left hover:bg-soft-gray/50 transition-colors"
              >
                <span className="font-manrope font-semibold text-slate-primary text-sm md:text-base">
                  {t(item.q)}
                </span>
                <span
                  className={`w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-full bg-copper/15 transition-transform duration-300 ${
                    openIndex === idx ? 'rotate-180' : ''
                  }`}
                >
                  <i className="ri-arrow-down-s-line text-copper" />
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-500 ${
                  openIndex === idx ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-slate-primary/60 text-sm md:text-base leading-relaxed">
                    {t(item.a)}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}